import { render, staticRenderFns } from "./_health-area.vue?vue&type=template&id=161642cc&scoped=true&"
import script from "./_health-area.vue?vue&type=script&lang=js&"
export * from "./_health-area.vue?vue&type=script&lang=js&"
import style0 from "./_health-area.vue?vue&type=style&index=0&id=161642cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161642cc",
  null
  
)

export default component.exports